import React from 'react';
import { connect } from 'react-redux';
import { getDic } from '../assets/i18n/dictionary';
import { insertNewAccess, getSystemActions } from '../services/accessService';
import { getGroupsApi, addNewGroupApi, updateGroupApi, deleteGroupApi } from '../services/groupService';
import { createGroupModel, convertFormToGroupObject, convertGroupObjectToForm } from '../models/groupModel';
import { validateForm } from '../utils';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/DeleteForever';
//Imports de components
import {
  MenuButton,
  BackButton,

  Table,
  Alert,
  Loading,
  Container,
  FormRow,
  FormColumn,
  GridRow,
  GridCell,
  TextMedium,
  Checkbox,
  Button,
  Dialog,
  InputFieldOutlined,
  TextSmall,
  InfiniteScroll,
  SelectList,
  Modal,
} from '../components';

const GroupRegisterPage = (props) => {
  const [state, setState] = React.useState(true);

  //Alert control
  const [alertOpen, setAlertOpen] = React.useState(false);
  const [alertTitle, setAlertTitle] = React.useState("");
  const [alertMessage, setAlertMessage] = React.useState("");

  //Loading control
  const [loadingMessage, setLoadingMessage] = React.useState(getDic("carregando"));
  const [openLoading, setOpenLoading] = React.useState(true);

  //Dialog control
  const [dialogConfirmOpen, setDialogConfirmOpen] = React.useState(false);
  const [dialogConfirmKey, setDialogConfirmKey] = React.useState("");
  const [dialogConfirmKeyErrorMessage, setDialogConfirmKeyErrorMessage] = React.useState("");

  //Modal Control
  const [openModal, setOpenModal] = React.useState(false);

  const [groupsList, setGroupsList] = React.useState([]);
  const [chosenGroup, setChosenGroup] = React.useState(null);
  const [newGroupForm, setNewGroupForm] = React.useState([]);

  React.useEffect(() => {
    //Bloqueio caso o usuário não seja admin
    if (!props.user.isAdmin) {
      props.history.goBack();
    }

    var helpButton = document.getElementById("launcher");
    if (helpButton) {
      helpButton.style.visibility = 'hidden';
    }

    getGroups();
    insertNewAccess(props.match.url, "", getSystemActions().accessPage);

    return () => {
      var helpButton = document.getElementById("launcher");
      if (helpButton) {
        helpButton.style.visibility = 'visible';
      }
      insertNewAccess(props.match.url, "", getSystemActions().exitPage);
    }
  }, []);

  const getGroups = () => {
    setOpenLoading(true);

    getGroupsApi(props.event.id)
      .then(res => {
        setGroupsList(res);
      })
      .catch(() => {
        setAlertOpen(true);
        setAlertTitle(getDic("erro"));
        setAlertMessage(getDic("sem-conexao"));
      })
      .finally(() => {
        setOpenLoading(false);
      })
  }

  const onChangeHandler = (index, value) => {
    var _newForm = newGroupForm;
    _newForm[index].value = value;
    setNewGroupForm(_newForm);
    setState(state === true ? false : true);
  }

  const resetGroupForm = () => {
    const _newGroup = createGroupModel();
    const _newForm = convertGroupObjectToForm(_newGroup);
    setNewGroupForm(_newForm);
  }

  const createNewGroup = () => {
    const _newGroup = createGroupModel();
    const _newForm = convertGroupObjectToForm(_newGroup);
    setNewGroupForm(_newForm);
    setOpenModal(true);
  }

  const editGroup = (group) => {
    const _newForm = convertGroupObjectToForm(group);
    setNewGroupForm(_newForm);
    setOpenModal(true);
  }

  const inactiveGroup = () => {
    setOpenLoading(true);
    setLoadingMessage(getDic("salvando"));

    deleteGroupApi(chosenGroup.id)
      .then(res => {
        const _newGroupList = [];
        groupsList.forEach(item => {
          if (item.id !== chosenGroup.id) {
            _newGroupList.push(item);
          }
        });
        _newGroupList.sort((a, b) => {
          return (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0)
        });
        setGroupsList(_newGroupList);
        setAlertOpen(true);
        setAlertTitle("");
        setAlertMessage(getDic("enviado-sucesso"));
      })
      .catch(err => {
        setAlertOpen(true);
        setAlertTitle(getDic("erro"));
        setAlertMessage(getDic("enviado-erro"));
        setOpenLoading(false);
      })
      .finally(() => {
        setOpenLoading(false);
      })
  }

  const saveGroup = async () => {
    var validation = validateForm(newGroupForm);
    if (validation.isValid) {

      var _newGroup = convertFormToGroupObject(newGroupForm);

      setOpenLoading(true);
      setLoadingMessage(getDic("salvando"));

      _newGroup.eventId = props.event.id;

      var _error = false;
      const _newGroupList = [];

      if (_newGroup.id > 0) {
        await updateGroupApi(_newGroup)
          .then(res => {
            _newGroupList.push(res);
          })
          .catch(err => {
            _error = true;
          })
      }
      else {
        await addNewGroupApi(_newGroup)
          .then(res => {
            _newGroup.id = res.id;
            _newGroupList.push(_newGroup);
          })
          .catch(err => {
            _error = true;
          })
      }

      if (_error) {
        setAlertOpen(true);
        setAlertTitle(getDic("erro"));
        setAlertMessage(getDic("enviado-erro"));
        setOpenLoading(false);
      }
      else {
        groupsList.forEach(item => {
          if (item.id !== _newGroup.id) {
            _newGroupList.push(item);
          }
        });
        _newGroupList.sort((a, b) => {
          return (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0)
        });
        setGroupsList(_newGroupList);
        setAlertOpen(true);
        setAlertTitle("");
        setAlertMessage(getDic("enviado-sucesso"));
        resetGroupForm();
        setOpenLoading(false);
        setOpenModal(false);
        setState(state === true ? false : true);
      }
    }
    else {
      setNewGroupForm(validation.form);
    }
  }

  return (
    <Container background="#e8eced" align="center">
      <FormRow align="center" background="#e8eced" margin="0px">
        <div>
          <MenuButton history={props.history} />
          <BackButton history={props.history} color="#212121">
            {getDic("voltar").toUpperCase()}
          </BackButton>

        </div>

        <FormRow
          minHeight="60px"
          align="center"
          background="#e8eced"
          margin="0px"
        />
        <FormRow
          minHeight="60px"
          align="flex-end"
          background="#e8eced"
          margin="0px"
          paddingTop="5px"
        >
          <div style={{ paddingRight: "10px", maxWidth: "400px" }}>
            <Button
              color="green"
              textColor="white"
              onClick={() => createNewGroup()}
            >
              {`${getDic("cadastrar")} ${getDic("grupo")}`}
            </Button>
          </div>
        </FormRow>

        <FormColumn align="center" background="#e8eced" margin="0px" padding="5px">
          {groupsList.length > 0 ? (
            <InfiniteScroll
              pageStart={0}
              dataLength={groupsList.length}
              height={"79vh"}
            >
              <GridRow backgroundColor="#d9d9d9">
                <GridCell width="20%" border top first>
                  <TextMedium>ID</TextMedium>
                </GridCell>
                <GridCell width="60%" border top>
                  <TextMedium>{getDic("nome").toUpperCase()}</TextMedium>
                </GridCell>
                <GridCell width="20%" border top>
                  <TextMedium>{getDic("acao").toUpperCase()}</TextMedium>
                </GridCell>
              </GridRow>

              {groupsList.map((item, i) => {
                return (
                  <GridRow
                    key={item.id}
                    autoColor={i}
                  >
                    <GridCell width="20%" border first>
                      <TextMedium>{item.id}</TextMedium>
                    </GridCell>
                    <GridCell width="60%" border>
                      <TextMedium>{item.name}</TextMedium>
                    </GridCell>
                    <GridCell width="20%" border>
                      <EditIcon onClick={() => editGroup(item)} style={{ cursor: "pointer" }} />
                      <DeleteIcon
                        onClick={() => {
                          setChosenGroup(item);
                          setDialogConfirmOpen(true);
                        }}
                        style={{ cursor: "pointer" }}
                      />
                    </GridCell>
                  </GridRow>
                );
              })}
            </InfiniteScroll>
          ) : (
            <TextMedium>{getDic("pesquisa-sem-resultado")}</TextMedium>
          )}
        </FormColumn>

        <Modal
          isVideo
          height="80vh"
          open={openModal}
          closeButtonClick={e => setOpenModal(false)}
          onClose={ret => {
            setOpenModal(false);
          }}
        >
          <Container background="#e8eced" align="left" height="100%" >
            <FormColumn padding="5px" margin="0px" background="#e8eced">
              {newGroupForm.map((item, i) => {
                if (i === 0) {
                  return (
                    <>
                      <FormRow key={item.id} align="center" paddingTop="7px">
                        <TextMedium>
                          {item.value > 0 ? (
                            `${getDic("editar")} ${getDic("grupo")}`
                          ) : (
                            `${getDic("novo")} ${getDic("grupo")}`
                          )}
                        </TextMedium>
                      </FormRow>
                    </>
                  )
                }
                else {
                  if (item.type === "select" && item.values) {
                    return (
                      <FormRow key={item.id} align="center" paddingTop="7px">
                        <SelectList
                          required={item.required}
                          error={item.error}
                          errorMessage={item.errorMessage}
                          title={item.name}
                          width="100%"
                          value={item.value}
                          menuItens={item.values}
                          onChange={async (event) =>
                            onChangeHandler(i, event.target.value)
                          }
                          multiple={Array.isArray(item.value) ? true : false}
                        />
                      </FormRow>
                    );
                  }
                  else {
                    return (
                      <FormRow key={item.id} align="center" paddingTop="7px">
                        <InputFieldOutlined
                          key={item.id}
                          required={item.required}
                          maxLength={item.maxLength}
                          error={item.error}
                          errorMessage={item.errorMessage}
                          value={item.value}
                          title={item.name}
                          type={item.type}
                          onChange={(event) => {
                            onChangeHandler(i, event.target.value)
                          }}
                        />
                      </FormRow>
                    );
                  }
                }
              })}
              <FormRow align="center" paddingTop="7px">
                <Button
                  text={getDic("salvar")}
                  onClick={() => saveGroup()}
                />
              </FormRow>
            </FormColumn>
          </Container>
        </Modal>

        <Alert
          open={alertOpen}
          onClose={() => setAlertOpen(false)}
          onClick={() => setAlertOpen(false)}
          title={alertTitle}
          message={alertMessage}
        />

        <Dialog
          open={dialogConfirmOpen}
          onClose={() => setDialogConfirmOpen(false)}
          title={getDic("atencao")}
          textButtonYes={getDic("inativar")}
          onClickYes={() => {
            if (dialogConfirmKey && dialogConfirmKey != "" && dialogConfirmKey.toUpperCase() === "SIM") {
              inactiveGroup();
              setDialogConfirmOpen(false);
              setDialogConfirmKey("");
            }
            else {
              setDialogConfirmKeyErrorMessage(true);
              setTimeout(() => {
                setDialogConfirmKeyErrorMessage(false);
              }, 3000); // 1 minuto = 60000
            }
          }}
          textButtonNo={getDic("cancelar")}
          onClickNo={() => {
            setDialogConfirmOpen(false);
            setDialogConfirmKey("");
          }}
        >
          <FormRow>
            <TextSmall>
              {getDic("confirmacao-de-acao")}
            </TextSmall>
          </FormRow>
          <FormRow align="center" paddingTop="5px">
            <InputFieldOutlined
              key="password"
              value={dialogConfirmKey}
              onChange={event => setDialogConfirmKey(event.target.value)}
            />
          </FormRow>
          {dialogConfirmKeyErrorMessage ? (
            <TextSmall color="red">{getDic("erro")}</TextSmall>
          ) : (null)}
        </Dialog>

        <Loading open={openLoading} message={loadingMessage} />
      </FormRow>
    </Container>
  )
}

function mapStateToProps(state) {
  return {
    event: state.event,
    user: state.user,
  }
}

export default connect(mapStateToProps, null)(GroupRegisterPage);
